import React, { useEffect, useState } from "react";
import { Input, theme } from "@clearabee/ui-library-native";
import { CustomImage } from "@clearabee/ui-library-native/dist/Core/Form/Inputs/InputImage/InputImage";
import { styles } from "./ProductDetailsUpload.styles";
import { useTranslation } from "react-i18next";

export interface ProductDetailsUploadProps {
  onImageChange: (files: File[]) => void;
  initialImages?: CustomImage[];
}

export const ProductDetailsUpload = ({
  onImageChange,
  initialImages,
}: ProductDetailsUploadProps): React.ReactElement => {
  const [images, setImages] = useState<File[]>(
    initialImages?.flatMap(({ file }) => (file instanceof File ? file : [])) ||
      [],
  );
  const [translate] = useTranslation();

  useEffect(() => {
    onImageChange(images);
  }, [images]);

  return (
    <Input.Image
      maxSelection={3}
      smallThumbnail
      name="image"
      as="file"
      onChange={(files) => setImages(files)}
      styles={styles.image}
      buttonLabelStyles={{
        marginLeft: theme.spacing.xsmall,
      }}
      initialImages={initialImages}
      buttonLabel={
        images.length === 3
          ? ""
          : images.length === 0
          ? translate("hwa.screens.productDetails.uploadPhoto")
          : "+"
      }
      modalStyles={{ maxHeight: "60%" }}
    />
  );
};
